<div class="hold-transition sidebar-mini layout-navbar-fixed layout-footer-fixed">
    <div class="wrapper">
        <app-header></app-header>
        <app-sidebar [page]="'hr'" [subPage]="'employee-profiles-kin'"></app-sidebar>

        <div class="content-wrapper">
            <div class="content-header">
                <div class="container-fluid">
                    <div class="row mb-2">
                        <div class="col-sm-6">
                            <h1 class="m-0">Staff Details</h1>
                        </div>
                        <div class="col-sm-6">
                            <ol class="breadcrumb float-sm-right">
                                <li class="breadcrumb-item"><a [routerLink]="['/']">Home</a></li>
                                <li class="breadcrumb-item"><a [routerLink]="['/hr/employee-profiles-kin']">HR &amp; People</a></li>
                                <li class="breadcrumb-item active">Staff Details</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>

            <section class="content">
                <div class="container-fluid">
                    <div class="card" *ngIf="loading">
                        <div class="card-body">Loading staff details...</div>
                    </div>

                    <ng-container *ngIf="!loading && staff">
                        <div class="row">
                            <div class="col-lg-4">
                                <div class="card card-primary card-outline">
                                    <div class="card-body box-profile">
                                        <div class="text-center">
                                            <img class="profile-user-img img-fluid img-circle staff-passport"
                                                [src]="passportUrl() || placeholderUrl()"
                                                [alt]="staffName(staff)">
                                        </div>

                                        <h3 class="profile-username text-center">{{ staffName(staff) }}</h3>
                                        <p class="text-muted text-center">{{ displayValue(staff.jobTitle) }}</p>

                                        <ul class="list-group list-group-unbordered mb-3">
                                            <li class="list-group-item">
                                                <b>Employee No</b> <a class="float-right">{{ displayValue(staff.employeeNumber) }}</a>
                                            </li>
                                            <li class="list-group-item">
                                                <b>Personal Email</b> <a class="float-right">{{ displayValue(staff.email) }}</a>
                                            </li>
                                            <li class="list-group-item" *ngIf="canViewFullProfile()">
                                                <b>Corporate Email</b> <a class="float-right">{{ displayValue(staff.c_email) }}</a>
                                            </li>
                                            <li class="list-group-item">
                                                <b>Phone</b> <a class="float-right">{{ displayValue(staff.phone) }}</a>
                                            </li>
                                            <li class="list-group-item">
                                                <b>Countries</b> <a class="float-right">{{ (staff.countries || []).join(', ') || displayValue(staff.country) }}</a>
                                            </li>
                                        </ul>

                                        <a class="btn btn-default btn-block" [routerLink]="['/hr/employee-profiles-kin']">Back to Staff</a>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-8">
                                <div class="card card-primary card-outline card-tabs">
                                    <div class="card-header p-0 pt-1">
                                        <ul class="nav nav-tabs" id="staff-tabs" role="tablist">
                                            <li class="nav-item">
                                                <a class="nav-link active" id="details-tab" data-toggle="pill" href="#details" role="tab" aria-controls="details" aria-selected="true">Details</a>
                                            </li>
                                            <li class="nav-item">
                                                <a class="nav-link" id="mini-org-tab" data-toggle="pill" href="#mini-org" role="tab" aria-controls="mini-org" aria-selected="false">Org Chart</a>
                                            </li>
                                            <li class="nav-item" *ngIf="canViewFullProfile()">
                                                <a class="nav-link" id="account-tab" data-toggle="pill" href="#account" role="tab" aria-controls="account" aria-selected="false">Account</a>
                                            </li>
                                            <li class="nav-item">
                                                <a class="nav-link" id="profile-tab" data-toggle="pill" href="#profile-address" role="tab" aria-controls="profile-address" aria-selected="false">Profile &amp; Address</a>
                                            </li>
                                            <li class="nav-item" *ngIf="canViewFullProfile()">
                                                <a class="nav-link" id="ice-tab" data-toggle="pill" href="#ice" role="tab" aria-controls="ice" aria-selected="false">ICE</a>
                                            </li>
                                            <li class="nav-item" *ngIf="canViewFullProfile()">
                                                <a class="nav-link" id="kin-tab" data-toggle="pill" href="#next-of-kin" role="tab" aria-controls="next-of-kin" aria-selected="false">Next of KIN</a>
                                            </li>
                                            <li class="nav-item" *ngIf="canViewFullProfile()">
                                                <a class="nav-link" id="bank-tab" data-toggle="pill" href="#bank" role="tab" aria-controls="bank" aria-selected="false">Bank</a>
                                            </li>
                                            <li class="nav-item" *ngIf="canViewFullProfile()">
                                                <a class="nav-link" id="documents-tab" data-toggle="pill" href="#documents" role="tab" aria-controls="documents" aria-selected="false">Documents</a>
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="card-body">
                                        <div class="tab-content" id="staff-tabs-content">
                                            <div class="tab-pane fade show active" id="details" role="tabpanel" aria-labelledby="details-tab">
                                                <div class="row">
                                                    <div class="col-md-6 detail-item">
                                                        <span>Designation</span>
                                                        <strong>{{ displayValue(staff.jobTitle) }}</strong>
                                                    </div>
                                                    <div class="col-md-6 detail-item">
                                                        <span>Department</span>
                                                        <strong>{{ displayDepartment() }}</strong>
                                                    </div>
                                                    <div class="col-md-6 detail-item">
                                                        <span>Employment Type</span>
                                                        <strong>{{ displayValue(staff.employmentType) }}</strong>
                                                    </div>
                                                    <div class="col-md-6 detail-item">
                                                        <span>Hire Date</span>
                                                        <strong>{{ displayValue(staff.hireDate) }}</strong>
                                                    </div>
                                                    <div class="col-md-6 detail-item">
                                                        <span>Primary Country</span>
                                                        <strong>{{ displayValue(staff.country) }}</strong>
                                                    </div>
                                                    <div class="col-md-6 detail-item">
                                                        <span>Assigned Countries</span>
                                                        <strong>{{ (staff.countries || []).join(', ') || '-' }}</strong>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="tab-pane fade" id="mini-org" role="tabpanel" aria-labelledby="mini-org-tab">
                                                <div *ngIf="!organogram" class="text-muted">No reporting line has been set for this staff member.</div>

                                                <div class="mini-org" *ngIf="organogram">
                                                    <div class="mini-org-row mini-org-boss" *ngIf="organogram.directBoss || organogram.supervisor">
                                                        <div class="mini-org-label">Reports To</div>
                                                        <div class="mini-org-card">
                                                            <div class="mini-org-avatar">{{ staffName(organogram.directBoss || organogram.supervisor).slice(0, 1) }}</div>
                                                            <div>
                                                                <strong>{{ staffName(organogram.directBoss || organogram.supervisor) }}</strong>
                                                                <span>{{ staffDesignation(organogram.directBoss || organogram.supervisor) || 'Direct boss' }}</span>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="mini-org-row mini-org-current">
                                                        <div class="mini-org-label">Current Staff</div>
                                                        <div class="mini-org-card active">
                                                            <div class="mini-org-avatar">{{ staffName(organogram.staff || staff).slice(0, 1) }}</div>
                                                            <div>
                                                                <strong>{{ staffName(organogram.staff || staff) }}</strong>
                                                                <span>{{ organogram.role || staff.jobTitle || '-' }}</span>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="mini-org-row">
                                                        <div class="mini-org-label">Direct Reports</div>
                                                        <div class="mini-org-downlines" *ngIf="reportRows().length > 0; else noReports">
                                                            <div class="mini-org-card" *ngFor="let report of reportRows()">
                                                                <div class="mini-org-avatar">{{ staffName(report.staff || report).slice(0, 1) }}</div>
                                                                <div>
                                                                    <strong>{{ staffName(report.staff || report) }}</strong>
                                                                    <span>{{ report.role || staffDesignation(report.staff || report) || '-' }}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <ng-template #noReports>
                                                            <div class="text-muted">No direct reports.</div>
                                                        </ng-template>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="tab-pane fade" id="account" role="tabpanel" aria-labelledby="account-tab" *ngIf="canViewFullProfile()">
                                                <div class="row">
                                                    <div class="col-md-6 detail-item">
                                                        <span>Personal Email</span>
                                                        <strong>{{ displayValue(staff.email) }}</strong>
                                                    </div>
                                                    <div class="col-md-6 detail-item">
                                                        <span>Corporate Email</span>
                                                        <strong>{{ displayValue(staff.c_email) }}</strong>
                                                    </div>
                                                    <div class="col-md-6 detail-item">
                                                        <span>Phone</span>
                                                        <strong>{{ displayValue(staff.phone) }}</strong>
                                                    </div>
                                                    <div class="col-md-6 detail-item">
                                                        <span>Admin Access</span>
                                                        <strong>{{ staff.admin ? 'Linked' : 'Not linked' }}</strong>
                                                    </div>
                                                    <div class="col-md-6 detail-item" *ngIf="staff.admin">
                                                        <span>Admin Name</span>
                                                        <strong>{{ displayValue(staff.admin?.name) }}</strong>
                                                    </div>
                                                    <div class="col-md-6 detail-item" *ngIf="staff.admin">
                                                        <span>Admin Email</span>
                                                        <strong>{{ displayValue(staff.admin?.email) }}</strong>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="tab-pane fade" id="profile-address" role="tabpanel" aria-labelledby="profile-tab">
                                                <div class="row">
                                                    <div class="col-md-6 detail-item">
                                                        <span>Profile</span>
                                                        <strong>{{ displayValue(staff.profile?.summary || staff.profile?.notes) }}</strong>
                                                    </div>
                                                    <div class="col-md-6 detail-item">
                                                        <span>Date of Birth</span>
                                                        <strong>{{ displayValue(staff.profile?.dateOfBirth) }}</strong>
                                                    </div>
                                                    <div class="col-md-6 detail-item">
                                                        <span>Gender</span>
                                                        <strong>{{ displayValue(staff.profile?.gender) }}</strong>
                                                    </div>
                                                    <div class="col-md-6 detail-item">
                                                        <span>Nationality</span>
                                                        <strong>{{ displayValue(staff.profile?.nationality) }}</strong>
                                                    </div>
                                                    <div class="col-md-12 detail-item">
                                                        <span>Address</span>
                                                        <strong>{{ displayValue(staff.address?.address || staff.address?.addressLine1) }}</strong>
                                                    </div>
                                                    <div class="col-md-6 detail-item">
                                                        <span>City</span>
                                                        <strong>{{ displayValue(staff.address?.city) }}</strong>
                                                    </div>
                                                    <div class="col-md-6 detail-item">
                                                        <span>State</span>
                                                        <strong>{{ displayValue(staff.address?.state) }}</strong>
                                                    </div>
                                                    <div class="col-md-6 detail-item">
                                                        <span>Postal Code</span>
                                                        <strong>{{ displayValue(staff.address?.postalCode) }}</strong>
                                                    </div>
                                                    <div class="col-md-6 detail-item">
                                                        <span>Country</span>
                                                        <strong>{{ displayValue(staff.address?.country) }}</strong>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="tab-pane fade" id="ice" role="tabpanel" aria-labelledby="ice-tab" *ngIf="canViewFullProfile()">
                                                <div class="row">
                                                    <div class="col-md-6 detail-item">
                                                        <span>Name</span>
                                                        <strong>{{ displayValue(staff.ice?.name) }}</strong>
                                                    </div>
                                                    <div class="col-md-6 detail-item">
                                                        <span>Relationship</span>
                                                        <strong>{{ displayValue(staff.ice?.relationship) }}</strong>
                                                    </div>
                                                    <div class="col-md-6 detail-item">
                                                        <span>Phone</span>
                                                        <strong>{{ displayValue(staff.ice?.phone) }}</strong>
                                                    </div>
                                                    <div class="col-md-6 detail-item">
                                                        <span>Email</span>
                                                        <strong>{{ displayValue(staff.ice?.email) }}</strong>
                                                    </div>
                                                    <div class="col-md-12 detail-item">
                                                        <span>Address</span>
                                                        <strong>{{ displayValue(staff.ice?.address) }}</strong>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="tab-pane fade" id="next-of-kin" role="tabpanel" aria-labelledby="kin-tab" *ngIf="canViewFullProfile()">
                                                <div class="row">
                                                    <div class="col-md-6 detail-item">
                                                        <span>Name</span>
                                                        <strong>{{ displayValue(staff.nextOfKin?.name) }}</strong>
                                                    </div>
                                                    <div class="col-md-6 detail-item">
                                                        <span>Relationship</span>
                                                        <strong>{{ displayValue(staff.nextOfKin?.relationship) }}</strong>
                                                    </div>
                                                    <div class="col-md-6 detail-item">
                                                        <span>Phone</span>
                                                        <strong>{{ displayValue(staff.nextOfKin?.phone) }}</strong>
                                                    </div>
                                                    <div class="col-md-6 detail-item">
                                                        <span>Email</span>
                                                        <strong>{{ displayValue(staff.nextOfKin?.email) }}</strong>
                                                    </div>
                                                    <div class="col-md-12 detail-item">
                                                        <span>Address</span>
                                                        <strong>{{ displayValue(staff.nextOfKin?.address) }}</strong>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="tab-pane fade" id="bank" role="tabpanel" aria-labelledby="bank-tab" *ngIf="canViewFullProfile()">
                                                <div class="row" *ngIf="staff.bankAccount; else noBank">
                                                    <div class="col-md-6 detail-item">
                                                        <span>Bank</span>
                                                        <strong>{{ displayValue(staff.bankAccount.bankName) }}</strong>
                                                    </div>
                                                    <div class="col-md-6 detail-item">
                                                        <span>Account Name</span>
                                                        <strong>{{ displayValue(staff.bankAccount.accountName) }}</strong>
                                                    </div>
                                                    <div class="col-md-6 detail-item">
                                                        <span>Account Number</span>
                                                        <strong>{{ displayValue(staff.bankAccount.accountNumber) }}</strong>
                                                    </div>
                                                    <div class="col-md-6 detail-item">
                                                        <span>Account Type</span>
                                                        <strong>{{ displayValue(staff.bankAccount.accountType) }}</strong>
                                                    </div>
                                                    <div class="col-md-6 detail-item">
                                                        <span>Bank Code</span>
                                                        <strong>{{ displayValue(staff.bankAccount.bankCode) }}</strong>
                                                    </div>
                                                    <div class="col-md-6 detail-item">
                                                        <span>Currency</span>
                                                        <strong>{{ displayValue(staff.bankAccount.currency) }}</strong>
                                                    </div>
                                                </div>
                                                <ng-template #noBank>No bank account found.</ng-template>
                                            </div>

                                            <div class="tab-pane fade" id="documents" role="tabpanel" aria-labelledby="documents-tab" *ngIf="canViewFullProfile()">
                                                <div class="document-row">
                                                    <div>
                                                        <strong>Passport photograph</strong><br>
                                                        <small>{{ documentByType('passport')?.originalName || 'No passport uploaded' }}</small>
                                                        <a class="ml-2" *ngIf="documentUrl(documentByType('passport'))" [href]="documentUrl(documentByType('passport'))" target="_blank">View</a>
                                                    </div>
                                                    <label class="btn btn-sm btn-outline-primary mb-0">
                                                        Upload <input type="file" hidden accept="image/*" (change)="uploadPassport($event)">
                                                    </label>
                                                </div>
                                                <div class="document-row">
                                                    <div>
                                                        <strong>Resume</strong><br>
                                                        <small>{{ documentByType('resume')?.originalName || 'No resume uploaded' }}</small>
                                                        <a class="ml-2" *ngIf="documentUrl(documentByType('resume'))" [href]="documentUrl(documentByType('resume'))" target="_blank">View</a>
                                                    </div>
                                                    <label class="btn btn-sm btn-outline-primary mb-0">
                                                        Upload <input type="file" hidden (change)="uploadResume($event)">
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </section>
        </div>

        <app-footer></app-footer>
    </div>
</div>
